import React from 'react';
import { EiqSelect } from 'eiq-storybook';
import { CapOverallStatusesOption } from 'src/components/CapBox/constants';
import { useUpdateOverallCapStatus } from 'src/hooks/cap';
import {
  CapOverallStatusPropTypes,
  CapOverallStatusDefaultPropTypes,
} from 'src/components/CapOverallStatus/propTypes';
import { notification } from 'src/components/Notification';
import s from 'src/components/CapOverallStatus/CapOverallStatus.styles';

const CapOverallStatus = ({ editable, value, jobId, setOverallCapStatusValue }) => {

  const updateOverallStatus = useUpdateOverallCapStatus();

  const convertToSnakeCase = (str) => {
    return str.replace(/[A-Z]/g, (letter, index) => {
      return index === 0 ? letter.toLowerCase() : `_${letter.toLowerCase()}`;
    });
  };

  const getCapOverallStatusValue = (statusValue) => {
    if (!statusValue) {
      return CapOverallStatusesOption.find(status => convertToSnakeCase(status.key) === 'null');
    }
    return CapOverallStatusesOption.find(status => convertToSnakeCase(status.key) === statusValue);
  };

  const onStatusSelected = async (key) => {
    let selectedStatusValue = convertToSnakeCase(key);
    /**
     * because we are working on the keys of CapOverallStatuses object and
     * one of its keys depicts absence or null
     */
    selectedStatusValue = selectedStatusValue === 'null' ? null : selectedStatusValue;
    try {
      await updateOverallStatus({ jobId, overallCapStatus: selectedStatusValue });
      setOverallCapStatusValue(selectedStatusValue);
    } catch (e) {
      notification.error(e.message);
    }

  };

  return (
    <>
      <s.CapOverallStatusLabel>CAP Overall Status</s.CapOverallStatusLabel>
      <s.CapOverallStatusWrapper>
        <EiqSelect 
          hasCustomChips={true} 
          isDisabled={!editable}
          onChange={(_name, option) => {
            onStatusSelected(option.key);
          }}
          options={CapOverallStatusesOption} 
          value={getCapOverallStatusValue(value)}
        />
      </s.CapOverallStatusWrapper>
    </>
  );
};

CapOverallStatus.prototypes = CapOverallStatusPropTypes;
CapOverallStatus.defaultProps = CapOverallStatusDefaultPropTypes;

export default React.memo(CapOverallStatus);

